/**
 * @file routes/_app/settings/verification-types.tsx
 * @description 驗證類型字典維護頁（申請類別）。
 *
 * 對應 clients.verificationType（text[]，可複選）。字典項會出現在
 * 「組織客戶檔案 → 編輯客戶 → 驗證類型」下拉選單。
 * 停用後新增/編輯客戶時不會出現該選項，但既有客戶資料仍保留原值。
 */

import { createFileRoute } from '@tanstack/react-router';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/verification-types')({
  component: VerificationTypesPage,
});

/** 驗證類型維護頁 */
function VerificationTypesPage() {
  return (
    <LookupAdminPage
      resource="verification-types"
      resourceLabel="驗證類型"
      description="申請類別（初次申請(包含轉證) / 追蹤查驗1、2 / 展延查驗 / 增列查驗 / 減列查驗 / 不定期查驗 / 增加驗證場區 / 其他）。客戶建檔可複選。"
      nameMaxLength={50}
    />
  );
}
